module.exports = __webpack_public_path__ + "assets/img/2nd Yellow.webp?38137ae47cdc7668bf30f1384689e1f9";